
export default {
  name: "MainButton",
  props: {
    color: {
      type: String,
      required: false,
      default: 'white',
    },
    width: {
      type: String,
      required: false,
      default: '100%',
    },
    height: {
      type: String,
      required: false,
      default: '50'
    },
    redhover: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
